import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Input } from "@/components/ui/input";
import { useTranslation } from "@/hooks/useTranslation";

interface InventoryItem {
  id: string;
  item_name: string;
}

interface PurchaseItemPickerSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  items: InventoryItem[];
  onSelect: (item: InventoryItem) => void;
}

export function PurchaseItemPickerSheet({
  open,
  onOpenChange,
  items,
  onSelect,
}: PurchaseItemPickerSheetProps) {
  const { tDynamic } = useTranslation();
  const [search, setSearch] = useState("");

  const filtered = search.trim()
    ? items.filter((i) =>
        i.item_name.toLowerCase().includes(search.trim().toLowerCase())
      )
    : items;

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="h-auto max-h-[85vh] rounded-t-xl overflow-hidden flex flex-col">
        <SheetHeader className="text-left pb-2 shrink-0">
          <SheetTitle>{tDynamic("Select item")}</SheetTitle>
        </SheetHeader>
        <div className="px-1 pb-4 flex-1 min-h-0 overflow-hidden flex flex-col">
          <Input
            placeholder={tDynamic("Search items...")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="mb-3"
          />
          <ul className="overflow-y-auto flex-1 space-y-0.5">
            {filtered.length === 0 ? (
              <li className="py-4 text-center text-sm text-muted-foreground">
                {tDynamic("No items match")}
              </li>
            ) : (
              filtered.map((item) => (
                <li key={item.id}>
                  <button
                    type="button"
                    className="w-full text-left py-3 px-3 rounded-lg hover:bg-muted font-medium"
                    onClick={() => {
                      onSelect(item);
                      onOpenChange(false);
                    }}
                  >
                    {item.item_name}
                  </button>
                </li>
              ))
            )}
          </ul>
        </div>
      </SheetContent>
    </Sheet>
  );
}
